export default __webpack_public_path__ + "static/media/cover-auth.61aed510.png";